import React, { useEffect } from "react"

import { connect } from 'react-redux'
import { getHots, getChallenge } from '../actions/game'

import Navigation from "../components/Navigation"
import GameListContent from "../components/GameListContent"
import WebFooter from "../components/WebFooter"

export function GameList(props) {

    useEffect(() => {
        props.getHots()
        props.getChallenge()
    }, [])

    return (
        <div className="list-setting">
            <div className="list">
                {/* Navigation */}
                <div className="list-nav">
                    <Navigation />
                </div>

                <div className="list-frame">
                    <GameListContent hots={props.hots} challenge={props.challenge} />
                </div>

                {/* footer */}
                <div className="web-row web-footer-outer-box">
                    <footer className="web-footer">
                        <WebFooter />
                    </footer>
                </div>


            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    hots: state.game.hots,
    challenge: state.game.challenge,
})

const mapDispatchToProps = {
    getHots,
    getChallenge,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GameList)